export const OPERATION_TYPE_LOG_MAP = [
	{ value : 1, type : 'login', cn : '用户-登录'},
	{ value : 2, type : 'createAKeywordMonitor', cn : '关键词监控 - 创建'},
	{ value : 3, type : 'keywordRenewal', cn : '关键词监控 - 续期'},
	{ value : 4, type : 'keywordUpdate', cn : '关键词监控 - 修改'},
	{ value : 5, type : 'keywordDeletion', cn : '关键词监控 - 删除'},
	{ value : 6, type : 'brandAnalysisQuery',sub : 'keywordMonitoring', cn : '品牌分析(ABA) - 查询'},
	{ value : 7, type : 'signIn', cn : '用户-签到'},
	{ value : 8, type : 'reverseSearchKeywords', cn : '反查流量词 - 查询'},
	{ value : 9, type : 'trafficSource', cn : '查流量来源 - 查询'},
	{ value : 10, type : 'buyMembership', cn : '用户 - 开通会员'},
	{ value : 11, type : 'weeklyKeywordHistoryDate', cn : '品牌分析(ABA) - 历史记录'},
	{ value : 12, type : 'weeklyKeywordTrend', cn : '品牌分析(ABA) - 历史趋势'},
]

export function getOperationTypeCnByType(type){
	let o = OPERATION_TYPE_LOG_MAP.find(i => i.type === type || i.sub === type)
	if (o) return o.cn
}